/**
 * List of events used by booking EcommerceAnalytics
 *
 */
export const bookingEcommerceAnalytics = {
  BOOKINGS_ECOMMERCE_ANALYTICS: 'Bookings.BookingEcommerceAnalytics'
}
